import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { SERVICE_REQUEST_EXTEND_TENURE, LOAN_CURRENCY_TYPE_BHD, LOAN_CURRENCY_TYPE_USD } from "../utilities";
import Cookies from 'js-cookie';
window.Buffer = window.Buffer || require("buffer").Buffer;
const ServiceRequestsDetails = (props) => {
  const navigate = useNavigate();
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
  useEffect(() => {}, []);

  const handleClose = () => {
    props.onHide();
  };

  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-190w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          onHide={handleClose}
          closeButton
          className="modal_title"
          style={{ height: "55px" }}
        >
          <Modal.Title id="example-custom-modal-styling-title">
            <div>
              {" "}
              <div className="heading_new_loan  ps-2">
                Service Request Details
                <div className="text_st_status ms-5">Status : </div>
                <div className="text_bolder_sr ms-2">{props.data.status}</div>
              </div>
              <div className=""></div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-2">
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="row mb-3">
                <div className="col">
                  <p className="text_st">Service type</p>
                  <div className="bolder_text">
                    {props.data.service_type_name === undefined ? '-' : props.data.service_type_name}
                  </div>
                </div>
                <div className="col">
                  <p className="text_st">Service Reference No.</p>
                  <div className="bolder_text">
                    {props.data.service_request_reference_no === undefined ? '-' : props.data.service_request_reference_no}
                  </div>
                </div>
                <div className="col">
                  <p className="text_st">Loan Type</p>
                  <div className="bolder_text">{props.data.loan_type_name === undefined ? '-' : props.data.loan_type_name}</div>
                </div>
                <div className="col">
                  {/* QA #44: an extension request shows the months requested, not the loan's tenure. */}
                  {Number(props.data.service_type_code) === SERVICE_REQUEST_EXTEND_TENURE ? (
                    <>
                      <p className="text_st">Requested Extension </p>
                      <div className="bolder_text">
                        {props.data.extend_tenure} {Number(props.data.extend_tenure) === 1 ? " Month" : " Months"}
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="text_st">Requested Tenure </p>
                      <div className="bolder_text">
                        {" "}
                        {props.data.loan_tenure}{" "}
                        {props.data.loan_tenure === 1 ? " Month" : " Months"}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="row mt-4 mb-3">
                <div className="col-3">
                  <p className="text_st">Amount Requested</p>
                  <span className="bolder_text">
                    {props.data.loan_amount === undefined ? "-" : props.data.loan_currency == LOAN_CURRENCY_TYPE_USD
                      ? "$\u00A0" + Number(props.data.loan_amount).toLocaleString()
                      : props.data.loan_currency == LOAN_CURRENCY_TYPE_BHD
                      ? LOAN_CURRENCY_TYPE_BHD + " " + Number(props.data.loan_amount).toLocaleString()
                      : "-" }
                  </span>
                </div>
                <div className="col-3">
                  <p className="text_st">Loan Purpose</p>
                  <div className="bolder_text">{props.data.loan_purpose === undefined || props.data.loan_purpose === '' ? '-' : props.data.loan_purpose}</div>
                </div>
                <div className="col-3">
                  <p className="text_st">Collateral</p>
                  <div className="bolder_text">{props.data.collateral ? props.data.collateral : '-'}</div>
                </div>
              </div>
              <div className="row mb-1 mt-1">
                <div className="col">
                  <p className="text_st my_serv_custm_notes"> Notes</p>
                  <div className="bolder_text  "> {props.data.notes ==='' || props.data.notes === undefined? '-':props.data.notes}</div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex  ps-3 pe-3">
          <div>
            <button
              className="btn btn_background mx-2 px-3 py-2"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ServiceRequestsDetails;

